import { useEffect, useState, useRef } from "react";
import {
  WHATS_NEW_CONTENT,
  WHATS_NEW_VERSION,
  WHATS_NEW_DEPLOY_DATE,
  WHATS_NEW_EXPIRY_DAYS
} from "../../constants/whatsNewContent";
import "../../components/common/whatsNewBanner.css";

const SHOW_WHATS_NEW_BANNER = true;

const WhatsNewBanner = ({ isManualOpen, onClose }) => {
  const [visible, setVisible] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const hasInitialized = useRef(false);
  const hasShown = useRef(false);


useEffect(() => {
  if (!SHOW_WHATS_NEW_BANNER) return;

  if (hasInitialized.current) return;
  hasInitialized.current = true;

  const alreadySeen = localStorage.getItem(WHATS_NEW_VERSION);

  const deployDate = new Date(WHATS_NEW_DEPLOY_DATE);
  const today = new Date();
  const diffDays = Math.floor((today - deployDate) / (1000 * 60 * 60 * 24));

  const expired = diffDays >= WHATS_NEW_EXPIRY_DAYS;

  if (!alreadySeen && !expired && !isManualOpen) {
  localStorage.setItem(WHATS_NEW_VERSION, "true"); // mark immediately
  setVisible(true);
}
}, [isManualOpen]);

const handleClose = () => {

  // mark banner as seen when closed
  if (!isManualOpen) {
    localStorage.setItem(WHATS_NEW_VERSION, "true");
  }

  if (isManualOpen) {
    onClose();
  } else {
    setVisible(false);
  }
};
  // Condition to show: Banner is enabled AND (Auto-visible OR Manually triggered)
  const isActuallyVisible = SHOW_WHATS_NEW_BANNER && (visible || isManualOpen);

  if (!isActuallyVisible) return null;

  return (
    <div className="wn-overlay">
      <div className="wn-modal">
        <div className="wn-header">
          <h2>
            What’s New
            <span className="wn-version-tag">{'L7.0.0'}</span>
          </h2>
          <button className="wn-close" onClick={handleClose}>×</button>
        </div>

        <div className="wn-body">
          {WHATS_NEW_CONTENT.map((block, index) => (
            <div key={index} className="wn-section">
              <h4>{block.section}</h4>
              <ul>
                {block.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <div className="wn-footer">
          {/* Hide checkbox if opened manually from sidebar */}
          {!isManualOpen ? (
            <label>
              <input
                type="checkbox"
                onChange={(e) => setDontShowAgain(e.target.checked)}
              />
              Don’t show this again
            </label>
          ) : <div />} 

          <button className="wn-btn" onClick={handleClose}>
            {isManualOpen ? "Close" : "I have read it"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhatsNewBanner;